import React, { useState } from 'react';
import { Button, Dialog, DialogContent, Grid, IconButton, TextField, DialogTitle, Typography } from '@mui/material';
import DisabledByDefaultIcon from '@mui/icons-material/DisabledByDefault';
import axios from 'axios';

function UserSignUp({ setHandleOpen, handelOpen }) {
    const [username, setUsername] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [role, setRole] = useState(1);

    // Handle Sign Up form submission
    const handleSignUp = async (e) => {
        e.preventDefault();
        try {
            // Replace with your backend API URL for signing up
            const response = await axios.post('https://serverukautotech.ccsoftwares.com/Users/addUser', {
                username,
                email,
                password,
                role
            });

            // If the signup is successful, set a success message
            setSuccess('Registration successful! You can now log in.');
            setError('');

            // Clear the form fields
            setUsername('');
            setEmail('');
            setPassword('');

        } catch (err) {
            setSuccess('');
            setError('Error creating account. Please try again.');
        }
    };

    const handleClose = () => {
        setHandleOpen(false);
    };

    return (
        <>
            <Dialog
                aria-labelledby="customized-dialog-title"
                open={handelOpen}
            >
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: 'absolute',
                        right: 25,
                        top: 20,
                        height: 50,
                        width: 50,
                        color: (theme) => theme.palette.grey[200],
                    }}
                >
                    <DisabledByDefaultIcon sx={{ color: '#000000', fontSize: '40px' }} />
                </IconButton>
                <DialogTitle sx={{
                    color: '#000000',
                    fontSize: '35px',
                    fontFamily: 'sans-serif',
                    fontWeight: '1000',
                    display: "flex",
                    justifyContent: "center",
                    alignContent: 'center'
                }}>
                    Sign Up
                </DialogTitle>
                <DialogContent>
                    <form onSubmit={handleSignUp}>
                        <Grid container spacing={4}>
                            <Grid item md={12} sx={{ display: 'flex', justifyContent: 'center', paddingTop: '10px' }}>
                            </Grid>
                            <Grid item md={12}>
                                <TextField
                                    id="username"
                                    label="Username"
                                    variant="outlined"
                                    size='large'
                                    fullWidth
                                    value={username}
                                    onChange={(e) => setUsername(e.target.value)}
                                />
                            </Grid>
                            <Grid item md={12}>
                                <TextField
                                    id="email"
                                    label="Email"
                                    variant="outlined"
                                    size='large'
                                    fullWidth
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                            </Grid>
                            <Grid item md={12}>
                                <TextField
                                    id="password"
                                    label="Password"
                                    type="password"
                                    variant="outlined"
                                    size='large'
                                    fullWidth
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                />
                            </Grid>
                            {error && (
                                <Grid item md={12}>
                                    <Typography color="error" align="center">{error}</Typography>
                                </Grid>
                            )}
                            {success && (
                                <Grid item md={12}>
                                    <Typography color="primary" align="center">{success}</Typography>
                                </Grid>
                            )}
                            <Grid item md={12} xs={12}>
                                <center>
                                    <Button
                                        variant="contained"
                                        size='large'
                                        sx={{
                                            width: '70%',
                                            fontFamily: 'sans-serif',
                                        }}
                                        type="submit"
                                    >
                                        Sign Up
                                    </Button>
                                </center>
                            </Grid>
                        </Grid>
                    </form>
                </DialogContent>
            </Dialog>
        </>
    );
}

export default UserSignUp;
